import { Logical } from './authentication-service-constants.js';
class PermissionMatcher {
    constructor(jwtToken) {
        this.permissionCache = new Map();
        this.checkPermission = (permission) => {
            if (!this.permissionCache.has(permission)) {
                this.fillCache(permission);
            }
            return this.permissionCache.get(permission) || false;
        };
        this.checkClaim = (entry) => {
            const [name, value] = entry;
            return this.tokenClaims[name] === value;
        };
        this.jwtToken = jwtToken;
        this.tokenPermissions = new Set(jwtToken.permissions);
        this.tokenClaims = this.jwtToken.claims;
    }
    fillCache(permission) {
        const permissionList = permission.split(':');
        let current = '', has = false;
        for (let i = 0; i < permissionList.length && !has; i++) {
            current += permissionList[i];
            has = this.tokenPermissions.has(current);
            const withWildcard = `${current}:*`;
            has = has || this.tokenPermissions.has(withWildcard);
            current += ':';
        }
        this.permissionCache.set(permission, has);
    }
    matchPermissions(permissions, logical) {
        if (!permissions.length)
            return true;
        switch (logical) {
            case Logical.AND: return permissions.every(this.checkPermission);
            case Logical.OR: return permissions.some(this.checkPermission);
            default: throw new Error(`Invalid logical: ${logical}.`);
        }
    }
    matchClaims(claims, logical) {
        const claimNames = Object.entries(claims);
        switch (logical) {
            case Logical.AND: return claimNames.every(this.checkClaim);
            case Logical.OR: return claimNames.some(this.checkClaim);
            default: throw new Error(`Invalid logical: ${logical}.`);
        }
    }
}
export { PermissionMatcher, };
//# sourceMappingURL=permission-matcher.js.map